module.exports = __webpack_public_path__ + "static/img/1.a1b9659.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1.png
// module id = LOA1
// module chunks = 13